import AccordionList from "@/components/accordionList";
import { FAQS } from "./constants";

const Faqs = () => {
  return <AccordionList items={FAQS} />;
};

export default Faqs;
